import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import {
    Grid,
    Typography,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

import FormSelect from 'Console/components/common/form/FormSelect';
import FormInput from 'Console/components/common/form/FormInput';
import InviteNewUsers from 'Console/components/common/InviteNewUsers';

// Other

const styles = (theme) => ({
    root: {
        margin: '42px 48px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '42px 48px',
            display: 'flex',
            flexDirection: 'column',
        },
    },
    formName: {
        width: '15%',
        marginRight: '3%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginRight: 0,
        },
    },
    items: {
        paddingBottom: theme.typography.pxToRem(20),
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            marginRight: 0,
            paddingBottom: theme.typography.pxToRem(20),
        },
    },
    invitePanel: {
        boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.25)',
    },
    details: {
        backgroundColor: theme.palette.background.default,
        padding: '20px 40px',
        fontSize: theme.typography.pxToRem(14),
        display: 'flex',
        flexDirection: 'column',
    },
    formInput: {
        width: '47%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
});

const CreateNewApplication = ({ classes, form, form: { setFieldsValue }, organizations = [] }) => (
    <>
        <Grid id="yeself-create-application-wrapper" className={classes.root}>
            <Grid container direction="row" alignItems="center" className={classes.items}>
                <Typography className={classes.formName} variant="body1">
                    <FormattedMessage id="General.domain" defaultMessage="Domain" />
                </Typography>

                <Grid id="yeself-create-application-form" className={classes.formInput}>
                    <FormInput
                        isRequired
                        fullWidth={false}
                        form={form}
                        type="text"
                        formItemKey="domain"
                        validateTrigger="onChange"
                        placeholder="www.nexthink.com"
                    />
                </Grid>
            </Grid>

            <Grid container direction="row" alignItems="center" className={classes.items}>
                <Typography className={classes.formName} variant="body1">
                    <FormattedMessage id="General.name" defaultMessage="Name" />
                </Typography>

                <Grid id="yeself-create-application-form" className={classes.formInput}>
                    <FormInput
                        isRequired
                        fullWidth={false}
                        form={form}
                        type="text"
                        formItemKey="name"
                        validateTrigger="onChange"
                        placeholder="New space for the vendor system"
                    />
                </Grid>
            </Grid>

            {organizations.length > 1 && (
                <Grid container direction="row" alignItems="center" className={classes.items}>
                    <Typography className={classes.formName} variant="body1">
                        <FormattedMessage id="General.organizations" defaultMessage="Organization" />
                    </Typography>

                    <Grid id="yeself-create-application-form" className={classes.formInput}>
                        <FormSelect
                            isRequired
                            form={form}
                            fullWidth={false}
                            formItemKey="organizationId"
                            optionList={organizations.map((organization) => ({
                                name: organization.name,
                                id: organization.id,
                            }))}
                        />
                    </Grid>
                </Grid>
            )}
        </Grid>

        <ExpansionPanel>
            <ExpansionPanelSummary className={classes.invitePanel} expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1">
                    <FormattedMessage id="Applications.createNewApp.invite" defaultMessage="Invite" />
                </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.details}>
                <InviteNewUsers form={form} />
            </ExpansionPanelDetails>
        </ExpansionPanel>
    </>
);

export default withStyles(styles)(CreateNewApplication);
